import axios, {formToJSON} from "axios";

import MessageSettingsLine from "./MessageSettingsLine";
import {APIBASE} from "../../config/Pfalzmarkt.config";
import React, {useEffect, useState} from "react";
import {useStore} from "../../store/store";
import * as Icon from "react-bootstrap-icons";


export default function Erzeuger(props) {
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    const [globalState, dispatch] = useStore();
    const [settings, setSettings] = useState({});
    const [isdCodes, setIsdCodes] = useState([]);
    let i = 0;
    function saveUserdata(event) {
        event.preventDefault();
        event.target.checkValidity();
        let formData = formToJSON(event.target);
        axios({
            method: 'post',
            url: APIBASE + 'api/erzeuger/saveMessageSettings',
            rejectUnauthorized: false,
            data: formData,
            headers: header
        }).then(result => {
            console.log('user settingssaved');
            fetchSettings();
        })
            .catch(error => {
                if (401 === error.response.status) {
                    dispatch('IS_401_ERROR', true);
                    dispatch('SET_AUTHTOKEN', null);
                }
                console.log(error);
            });

    }

    async function getIsdLIst() {
        try {
            const response = await axios.get(
                APIBASE + 'api/isd/get', {headers: header}
            );
            const data = await response.data;
            setIsdCodes(data);
        } catch (err) {
            dispatch('IS_401_ERROR', true);
            dispatch('SET_AUTHTOKEN', null);
            console.log(err); // Todo: Errorhandling
        }
    }

    const handleAddRow = () => {
        setSettings([...settings, {channel: 4}]);
        console.log(settings);
        i++;
    };


    const fetchSettings = async () => {
        try {
            const response = await axios.get(
                APIBASE + 'api/erzeuger/messageSettings', {headers: header}
            );
            const data = await response.data;
            setSettings(data);
        } catch (err) {
            dispatch('IS_401_ERROR', true);
            dispatch('SET_AUTHTOKEN', null);
            console.log(err); // Todo: Errorhandling
        }
    };

    useEffect(() => {
        let i = 0;
        fetchSettings();
        getIsdLIst();
    }, [globalState.token]);

    return (<div className="container-fluid">
            <h3>Erzeuger / Nutzerdaten verwalten</h3>
            <form onSubmit={saveUserdata}>
                {Object.values(settings).map((setting) => {
                    i++;
                    return <MessageSettingsLine key={i}
                                                id={setting.id} phoneCode={setting.phoneCode} channel={setting.channel}
                                                scope={setting.scope} value={setting.addresses}
                                                validated={setting.validated} isdCodes={isdCodes}/>
                })}
                <div className="row">
                    <div className="col-2">
                        <button type="button" onClick={handleAddRow} className="btn btn-secondary btn-sm">
                            <Icon.PlusCircle/>
                        </button>
                    </div>

                </div>
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <input type="submit" className="btn btn-success" value="Speichern"/>
                    </div>
                </div>
            </form>
        </div>
    )
}